<template>
  <v-layout row="row" justify-center="justify-center">
    <v-dialog v-model="dialog" persistent="persistent" max-width="500px">
      <v-card>
        <v-toolbar dark="dark" color="primary">
          <v-toolbar-title>{{ $t('labels.addCard') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon="icon" dark="dark" @click="cancel">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md="grid-list-md">
            <div class="card-wrapper section mb-3"></div>
            <form id="editCard">
              <v-layout row="row" wrap="wrap">
                <v-flex xs12="xs12">
                  <v-text-field id="cardNumber" v-model.trim="cardNumber" :error-messages="CardNumberErrors"
                    label="Card Number"></v-text-field>
                </v-flex>
                <v-flex xs12="xs12">
                  <v-text-field id="nameOnCard" v-model.trim="nameOnCard" :error-messages="NameOnCardErrors"
                    label="Name On Card"></v-text-field>
                </v-flex>
                <v-flex xs6="xs6">
                  <v-text-field id="cardExpiry" v-model.trim="cardExpiry" :error-messages="CardExpiryDateErrors"
                    label="Expiry Date"></v-text-field>
                </v-flex>
                <v-flex xs6="xs6">
                  <v-text-field id="cvvCode" v-model.trim="cvvCode" :error-messages="CardCVVErrors"
                    label="CVV Code"></v-text-field>
                </v-flex>
                <v-flex xs12="xs12">
                  <v-text-field v-model.trim="address" :error-messages="CardAddressErrors" label="Address"></v-text-field>
                </v-flex>
                <v-flex xs12="xs12">
                  <v-text-field v-model.trim="city" :error-messages="CardCityErrors" label="City"></v-text-field>
                </v-flex>
                <v-flex xs6="xs6">
                  <v-text-field v-model.trim="state" :error-messages="CardStateErrors" label="State"></v-text-field>
                </v-flex>
                <v-flex xs6="xs6">
                  <v-text-field v-model.trim="zipcode" :error-messages="CardZipcodeErrors" label="Zipcode"></v-text-field>
                </v-flex>
              </v-layout>
            </form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat="flat" @click="cancel">{{ $t('buttons.cancel') }}</v-btn>
          <v-btn :loading="loading" color="blue darken-1" dark="dark" @click="addCard">{{ $t('buttons.save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import creditCardService from '../service.js'

const { validationMixin } = require('vuelidate')
const {
  required,
  minLength,
} = require('vuelidate/lib/validators')

export default {
  props: {
    markItDefault: {
      default: false
    },
    cardDialog: {
      default: false
    },
  },
  name: 'credit-card-component',
  data() {
    return {
      loading: false,
      dialog: false,
      cardNumber: null,
      nameOnCard: null,
      cvvCode: null,
      cardExpiry: null,
      address: null,
      city: null,
      state: null,
      zipcode: null,
    }
  },
  watch: {
    cardDialog(val) {
      this.dialog = val
    }
  },
  mixins: [validationMixin],
  validations: {
    cardNumber: {
      required,
    },
    nameOnCard: {
      required,
      minLength: minLength(4),
    },
    cvvCode: {
      required,
      minLength: minLength(3),
    },
    cardExpiry: {
      required,
    },
    address: {
      required,
      minLength: minLength(2),
    },
    city: {
      required,
      minLength: minLength(2),
    },
    state: {
      required,
      minLength: minLength(2),
    },
    zipcode: {
      required,
      minLength: minLength(4),
    },
  },
  computed: {
    ...mapGetters('location', ['location']),
    CardNumberErrors() {
      const errors = []
      if (!this.$v.cardNumber.$dirty) return errors
      if (!this.$v.cardNumber.required) errors.push(this.$t('validations.fieldIsRequired'))
      return errors
    },
    NameOnCardErrors() {
      const errors = []
      if (!this.$v.nameOnCard.$dirty) return errors
      if (!this.$v.nameOnCard.required) errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.nameOnCard.minLength) errors.push(this.$t('validations.fieldMustbeatLeast4ChrLong'))
      return errors
    },
    CardExpiryDateErrors() {
      const errors = []
      if (!this.$v.cardExpiry.$dirty) return errors
      if (!this.$v.cardExpiry.required) errors.push(this.$t('validations.fieldIsRequired'))
      return errors
    },
    CardCVVErrors() {
      const errors = []
      if (!this.$v.cvvCode.$dirty) return errors
      if (!this.$v.cvvCode.required) errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.cvvCode.minLength) errors.push('Field musht be at least 3 characters long')
      return errors
    },
    CardAddressErrors() {
      const errors = []
      if (!this.$v.address.$dirty) return errors
      if (!this.$v.address.required) errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.address.minLength) errors.push(this.$t('validations.fieldMustbeatLeast4ChrLong'))
      return errors
    },
    CardCityErrors() {
      const errors = []
      if (!this.$v.city.$dirty) return errors
      if (!this.$v.city.required) errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.city.minLength) errors.push(this.$t('validations.fieldMustbeatLeast4ChrLong'))
      return errors
    },
    CardStateErrors() {
      const errors = []
      if (!this.$v.state.$dirty) return errors
      if (!this.$v.state.required) errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.state.minLength) errors.push(this.$t('validations.fieldMustbeatLeast4ChrLong'))
      return errors
    },
    CardZipcodeErrors() {
      const errors = []
      if (!this.$v.zipcode.$dirty) return errors
      if (!this.$v.zipcode.required) errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.zipcode.minLength) errors.push(this.$t('validations.fieldMustbeatLeast4ChrLong'))
      return errors
    },
  },
  methods: {
    ...mapActions('location', ['setLocation']),
    emptyCard() {
      this.cardNumber = null
      this.nameOnCard = null
      this.cvvCode = null
      this.cardExpiry = null
      this.address = null
      this.city = null
      this.state = null
      this.zipcode = null
      this.$v.$reset();
      this.loading = false
    },
    addCard() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$toasted.error('Invalid Input', {
          position: 'top-right',
          showHideTransition: 'slide',
          duration: 2000,
        })
      } else {
        this.loading = true
        var data = {
          nameOnCard: this.nameOnCard,
          cardNumber: this.cardNumber.split(' ').join(''),
          expiry: this.cardExpiry.split('/'),
          cvvCode: this.cvvCode,
          streetAddress: this.address,
          city: this.city,
          state: this.state,
          zipcode: this.zipcode,
          storeID: this.location.storeID,
          businessName: this.location.businessName,
          CSPID: this.location.CSPID,
          stripeID: this.location.stripeID,
        }
        data['month'] = data.expiry[0].split(' ').join('')
        data['year'] = data.expiry[1].split(' ').join('')
        data['markItDefault'] = this.markItDefault
        creditCardService.addCreditCard(data)
          .then(response => {
            this.setLocation(this.location.storeID)
            this.$emit('getCard')
            this.close()
          })
          .catch(err => {
            this.loading = false
            this.$swal('Add Card', err.data.data, 'error')
            console.log('err on strip', err)
          })
      }
    },
    cancel() {
      this.emptyCard()
      this.$emit('close')
    },
    close() {
      this.emptyCard()
      this.$emit('close')
    }
  },
  mounted() {
    var card = new Card({
      form: 'form#editCard', // *required*

      container: '.card-wrapper', // *required*

      formSelectors: {
        numberInput: 'input#cardNumber',
        expiryInput: 'input#cardExpiry',
        cvcInput: 'input#cvvCode',
        nameInput: 'input#nameOnCard'
      },

      width: 200,
      formatting: true,

      // Strings for translation - optional
      messages: {
        validDate: 'valid\ndate', // optional - default 'valid\nthru'
        monthYear: 'mm/yy',
      },
      placeholders: {
        number: '•••• •••• •••• ••••',
        name: 'Full Name',
        expiry: '••/••',
        cvc: '•••'
      },

      // if true, will log helpful messages for setting up Card
      debug: false // optional - default false
    });
  }
}
</script>

<style scoped></style>